"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GoogleCalendarEmbed;
const react_1 = __importDefault(require("react"));
require("./Calendar.scss");
function GoogleCalendarEmbed({ calendarId, view = 'MONTH', tz = 'America/Chicago', height = 600, }) {
    const src = `https://calendar.google.com/calendar/embed?src=${encodeURIComponent(calendarId)}&ctz=${encodeURIComponent(tz)}&mode=${encodeURIComponent(view)}&showTitle=0&showNav=1&showDate=1&showPrint=0`;
    return (react_1.default.createElement("div", { className: "calendar" },
        react_1.default.createElement("iframe", { title: "Google Calendar", src: src, style: {
                position: 'relative',
                left: 0,
                top: 0,
                width: '100%',
                height: `${height}px`,
                border: 0,
            }, frameBorder: "0", scrolling: "no" })));
}
